export const tabIndices = {
    RETAILER_VISIT: 0,
    OTHER_TASKS: 1,
};
